import React from 'react';

const ToolCard = ({ tool, onCreateClick }) => {
  const IconComponent = tool.icon;

  return (
    <div style={{
      background: 'var(--etpos-card, #fff)',
      borderRadius: '12px',
      boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
      padding: '1.75rem 1.5rem',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      gap: '0.75rem',
      transition: 'box-shadow 0.2s, transform 0.2s',
      cursor: 'default',
      border: '1px solid var(--etpos-border, #f0f0f0)',
    }}
      onMouseEnter={e => {
        e.currentTarget.style.boxShadow = '0 6px 20px rgba(22,163,74,0.15)';
        e.currentTarget.style.transform = 'translateY(-2px)';
      }}
      onMouseLeave={e => {
        e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
        e.currentTarget.style.transform = 'translateY(0)';
      }}
    >
      <div style={{
        width: '52px',
        height: '52px',
        borderRadius: '50%',
        background: 'var(--etpos-bg, #f0fdf4)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        <IconComponent size={26} color="#16a34a" strokeWidth={1.8} />
      </div>

      <h3 style={{
        fontSize: '1rem',
        fontWeight: 700,
        color: 'var(--etpos-text, #111827)',
        margin: 0,
        lineHeight: 1.3,
      }}>
        {tool.name}
      </h3>

      <p style={{
        fontSize: '0.82rem',
        color: 'var(--etpos-text-muted, #6b7280)',
        margin: 0,
        lineHeight: 1.5,
        flexGrow: 1,
      }}>
        {tool.description}
      </p>

      <button
        onClick={() => onCreateClick(tool)}
        style={{
          marginTop: '0.5rem',
          background: '#16a34a',
          color: '#fff',
          border: 'none',
          borderRadius: '6px',
          padding: '0.5rem 1.75rem',
          fontSize: '0.9rem',
          fontWeight: 600,
          cursor: 'pointer',
          transition: 'background 0.2s',
          width: '100%',
        }}
        onMouseEnter={e => e.currentTarget.style.background = '#15803d'}
        onMouseLeave={e => e.currentTarget.style.background = '#16a34a'}
      >
        Create
      </button>
    </div>
  );
};

export default ToolCard;
